import AbstractApiRequest from '@/api/apimodel/abstract-api-request'

export default class PostMemberInfoRequest extends AbstractApiRequest {
  memberCode = ''
  onetimeToken = ''
  postSite = ''
  capitalAmount = ''
}
